import TicketEditWrapper from './TicketEditWrapper';

export default TicketEditWrapper;
